import { Action, getModule, Module, Mutation, VuexModule } from 'vuex-module-decorators';
import { store } from '@/store/store';

import { getConfig } from '@/config';
import { hubClient } from '@tfpl/api-client';

@Module({
  name: 'CollaboratorNotesModule',
  store,
  dynamic: true,
  namespaced: true,
})
export class CollaboratorNotesModule extends VuexModule {
  /**************************************************************************
   * STATE
   *************************************************************************/
  private _loading = false;
  private _error = false;
  private _collabNotes: hubClient.CollaboratorNoteDto[] = [];

  /**************************************************************************
   * GETTERS
   *************************************************************************/
  get collabNotes(): hubClient.CollaboratorNoteDto[] {
    return this._collabNotes;
  }

  get loading(): boolean {
    return this._loading;
  }

  get error(): boolean {
    return this._error;
  }

  /**************************************************************************
   * MUTATIONS
   *************************************************************************/
  @Mutation
  setCollabNotes(collabNotes: hubClient.CollaboratorNoteDto[]): void {
    this._collabNotes = collabNotes;
  }

  @Mutation
  clearData(): void {
    this._collabNotes = [];
  }

  @Mutation
  setLoading(loading: boolean): void {
    this._loading = loading;
  }

  @Mutation
  setError(error: boolean): void {
    this._error = error;
  }

  /**************************************************************************
   * ACTIONS
   *************************************************************************/
  @Action({ rawError: true })
  public async fetchCollabNotes({
    collaboratorUuid,
    dateFrom,
    dateTo,
  }: {
    collaboratorUuid: string;
    dateFrom?: string;
    dateTo?: string;
  }): Promise<void> {
    this.setLoading(true);
    this.clearData();

    try {
      const { data: response } = await hubClient.V3CollaboratorNotesService.getManyV3({
        path: {
          tenant: getConfig().TENANT,
          company: getConfig().TENANT,
        },
        query: {
          limit: 999,
          offset: 0,
          collaboratorUuid,
          dateFrom,
          dateTo,
        },
        throwOnError: true,
      });
      this.setCollabNotes(response.data);
    } catch (err) {
      this.setError(true);
      console.log(err);
    } finally {
      this.setLoading(false);
    }
  }
}
export default getModule(CollaboratorNotesModule);
